export const NAV_REQUEST = 'NAV_REQUEST'
export const NAV_REQUEST_FAILED = 'NAV_REQUEST'
export const NAV_REQUEST_SUCCEEDED = 'NAV_REQUEST'
